import React, { memo, useCallback } from 'react';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { askUserForPaymentFiles } from 'reactApp/modules/uploadList/oldUploadListBridge';
import { IInputFile } from 'reactApp/modules/uploadList/uploadList.model';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';

import styles from './PopupWarnings.css';

interface IProps {
    file: IInputFile;
    isPhone?: boolean;
}

export const OverQuotaComponent = memo(({ file, isPhone = false }: IProps) => {
    const handleOverQuota = useCallback(() => {
        askUserForPaymentFiles('payment');
    }, []);

    const handleOverQuotaSkip = useCallback(() => {
        askUserForPaymentFiles('skip');
    }, []);

    const renderHeader = useCallback(() => <div>Невозможно загрузить файл {file.name}</div>, [file.name]);

    const renderContent = useCallback(() => {
        return (
            <div className={styles.content}>
                <div>Ваше Облако переполнено. Удалите лишнее или увеличьте его размер.</div>
            </div>
        );
    }, []);

    if (isPhone) {
        return (
            <MobileDialog
                mod="mobileV2"
                id="overquota-dialog"
                contextPadding={24}
                closable
                dimmer
                open
                topmost
                title={renderHeader()}
                text={renderContent()}
                onClose={handleOverQuotaSkip}
                actions={[
                    {
                        primary: true,
                        text: 'Пропустить файл',
                        id: 'skip',
                        onClick: handleOverQuotaSkip,
                    },
                ]}
            />
        );
    }

    return (
        <BaseConfirmDialog
            dataQAId="overquota-dialog"
            renderHeader={renderHeader}
            successButtonText="Посмотреть тарифы"
            cancelButtonText="Пропустить файл"
            buttons={[EButtonType.accept, EButtonType.cancel]}
            onSuccess={handleOverQuota}
            onClose={handleOverQuotaSkip}
            renderContent={renderContent}
            className={styles.root}
        />
    );
});
